import React from "react";
import DaliHelvarSceneForm from "../_forms/DaliHelvarSceneForm";
import HilightTable from "../../../../../components/HilightTable";
import {Button, Spinner} from "react-bootstrap";
import {modalActions} from "../../../../../actions/modal.actions";
import {withNamespaces} from "react-i18next";
import {connect} from "react-redux";
import {daliHelvarActions} from "../../../../../actions/dali-helvar.actions";
import CheckboxColumn from "../../../../../components/CheckboxColumn";

const DaliHelvarSceneTable = ({ t, list, showModal, editHelvarScene, removeHelvarScene}) => {

    const openModalEditScene = (row) => {
        showModal({
            open: true,
            title: t('edit_dali-scene'),
            component: <DaliHelvarSceneForm data={row} submitForm={(model) => editHelvarScene(model)} />
        }, "formModal");
    };

    const openModalDeleteScene = (row) => {
        showModal({
            open: true,
            title: t('are-you-sure'),
            message: t('delete-msg') + `<h5> ${row.label} </h5>`,
            confirmLabel: t('delete-btn'),
            confirmIcon: 'fa-trash',
            classNameBtnConfirm: 'btn-danger',
            dataId: row.id,
            confirmAction: () => {
                removeHelvarScene(row.id, row.daliHelvarGroupId)
            },
        }, 'confirm');
    };

    const columns = [
        {
            Header: 'scene-number',
            styleHeader: {width: '1px' },
            styleRow: { width: '1px' },
            accessor: 'sceneNumber'
        },
        {
            Header: 'block-number',
            styleHeader: {width: '1px' },
            styleRow: { width: '1px' },
            accessor: 'blockNumber'
        },
        {
            Header: 'label',
            accessor: 'label'
        },
        {
            Header: 'is-default',
            headerClassName: "text-center",
            classNameRow: 'text-center',
            styleHeader: {width: '1px' },
            styleRow: { width: '1px' },
            Cell: (props) => {
                const row = props.row.original;
                return (
                   <CheckboxColumn id={row.id} dataValue={row.isDefault} disabled={true} />
                )
            }
        },
        {
            Header: 'actions',
            headerClassName: "text-right",
            classNameRow: 'text-right',
            styleHeader: {width: '1px'},
            styleRow: {width: '1px'},
            Cell: (props) => {
                const row = props.row.original;
                return (
                    <React.Fragment>
                        <Button className="mx-1" variant={"primary"} onClick={() => openModalEditScene(row)}>
                            <i className="fas fa-edit" />
                        </Button>
                        <Button className="mx-1" variant={"danger"} onClick={() => openModalDeleteScene(row)}>
                            <i className="fas fa-trash" />
                        </Button>
                    </React.Fragment>
                );
            }
        }
    ];

    const tableResult = (
        list ?
            list.length === 0 ? (
                <div className="text-center p-4">
                    <h3>{t('dali-group-no-content')}</h3>
                </div>
            ) : (
                <HilightTable
                    columns={columns}
                    data={list}
                />
            ) : (
                <React.Fragment>
                    <Spinner animation={"border"} />
                    <p>Loading ...</p>
                </React.Fragment>
            )
    );

    return (
        <div className="col-md-12 mx-0 my-3 p-0">
            { tableResult }
        </div>
    );
};

const mapDispatchToProps = dispatch => ({
    hideModel: () => dispatch(modalActions.hideModal()),
    showModal: (modalProps, modalType) => {
       dispatch(modalActions.showModal({modalProps, modalType}))
    },
    editHelvarScene: (sceneModel) => {
        dispatch(daliHelvarActions.editHelvarScene(sceneModel))
    },
    removeHelvarScene: (sceneId, groupId) => {
        dispatch(daliHelvarActions.deleteHelvarScene(sceneId, groupId))
    }
});
export default withNamespaces()(connect(null, mapDispatchToProps)(DaliHelvarSceneTable));
